/**
 * Union initial requests of vue components and sends them as one batch
 */
class BatchMaster {
  constructor() {
    this.request_count = 0;
    this.queue = [];
    this.promise_list = [];
    this.is_already_init = false;
    this.request_func = null;
  }

  /**
   *
   * @param {number} count
   */
  setRequestCount(count) {
    this.request_count = count;
  }

  setRequestSender(request_func) {
    this.request_func = request_func;
  }

  /**
   *
   * @param {object} request_data rpc request object, look prepareRpcRequest in BaseApi.js
   * @return {Promise}
   */
  request(request_data) {
    this.addToQueue(request_data);
    return this.getPromise();
  }

  /**
   *
   * @return {Promise}
   */
  getPromise() {
    let resolver = false;
    let promise = {
      promise: new Promise(resolve => {
        resolver = resolve;
      }),
      resolve: false,
    };
    promise.resolve = resolver;
    this.promise_list.push(promise);

    return promise.promise;
  }

  /**
   *
   * @param {object} request_data rpc request object, look prepareRpcRequest in BaseApi.js
   */
  addToQueue(request_data) {
    this.queue.push(request_data);

    if (this.queue.length === this.request_count) {
      this.sendInitRequest();
    }
  }

  /**
   * @param {array} queue
   * @private
   */
  _toPlainArray(queue) {
    if (queue.length === 1) {
      return queue[0];
    }
    let result = [];
    for (let i = 0, len = queue.length; i < len; i++) {
      if (Array.isArray(queue[i])) {
        result.concat(queue[i]);
      } else {
        result.push(queue[i]);
      }
    }
    return result;
  }
  _saveQueueStructure(queue) {
    return queue.map(item => (Array.isArray(item) ? item.length : 1));
  }

  sendInitRequest() {
    /*
    if (this.api.dev_mode) {
      return this.promise_list[0].resolve({data: {"jsonrpc":"2.0","error":{"code":2104,"message":"Profile not registered."}}});
    }
    */
    const queue_structure = this._saveQueueStructure(this.queue);
    this.request_func(this._toPlainArray(this.queue)).then(response => {
      if (this.request_count === 1) {
        return this.promise_list[0].resolve(response);
      }
      /**
       * why spread response? we save basic axios scheme for response
       * axios.get('/user/12345')
       .then(function (response) {
        console.log(response.data);
        console.log(response.status);
        console.log(response.statusText);
        console.log(response.headers);
        console.log(response.config);
      });
       */
      let counter = 0;
      this.promise_list.forEach((promise, index) => {
        let data = response.data.slice(counter, queue_structure[index] + counter);
        if (data.length === 1) {
          data = data[0];
        }
        counter += queue_structure[index];
        promise.resolve({ ...response, data });
      });
      this.is_already_init = true;
      this.promise_list = [];
      this.queue = [];
      this.request_count = 0;
    });
  }
}
export default new BatchMaster();
